const pastaFeaturesSection = document.querySelector('.pasta-features-product-page-section');
const borderBottomEl = document.querySelector('.accordion-group .section-border__wrapper--bottom');

if (borderBottomEl) {
  borderBottomEl.style.display = pastaFeaturesSection ? 'block' : 'none';
}




const stickyHeader = document.querySelector('[data-header-sticky] [data-header-height]');
const productMainImage = document.querySelector('.product__slides.product-single__photos');
const ifLargeScreen = window.innerWidth > 750 ? true : false;


function updateTopPosition() {
  if (stickyHeader && ifLargeScreen) {
    const headerHeight = stickyHeader.offsetHeight;
    productMainImage.style.top = `${headerHeight}px`;
  }
}

window.addEventListener('scroll', () => {
  if (stickyHeader && stickyHeader.getBoundingClientRect().top === 0) {
    updateTopPosition();
  }
});


document.addEventListener('DOMContentLoaded', updateTopPosition);







